// removed by extract-text-webpack-plugin
module.exports = {"MainNav":"_2goG__n9","MainNav--row":"_2IXVxn5J","MainNav--column":"_1zsvmuG2","MenuItem":"_2uz_OivI","Active":"_3IGXh8Xj","Icon":"q_o8MifK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/main-nav/main-nav-component.styles.scss
// module id = 522
// module chunks = 0